import { ActionTypes } from 'utils/constants';
import axios from 'axios';
import { getEnvVar } from 'utils/get-env-var';

export const fetchContentStats = () => ({
    type: ActionTypes.FETCH_CONTENT_STATS,
    payload: axios.get(`${getEnvVar('API_BASE')}/content-stats`)
});

